import * as constants from '../constants/actions';

const initialState = {
	user: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
  	case constants.USER_SET:
      return userSet(state, action);
    default:
      return state;
  }
}

function userSet(state, action) {
  return Object.assign({}, state, {
    user: action.user
  });
}


// WEBPACK FOOTER //
// ./src/reducers/user.jsx